export default "__VITE_ASSET__2e958698__"